import type { PostTestInstanceResponseMarkItem } from 'services/assist-api/entities/test-instance-response-mark-item/types';

export enum MarkStatus {
  Assigned = 'assigned',
  InProgress = 'inProgress',
  NeedsReview = 'needsReview',
  InReview = 'inReview',
  ReturnedForMarking = 'returnedForMarking',
  FurtherEscalated = 'furtherEscalated',
  Reassigned = 'reassigned',
  FinishedSuccess = 'finishedSuccess',
  FinishedFailure = 'finishedFailure'
}

type SmallestTestInstanceResponseMark = {
  status: MarkStatus;
  needsAttention: boolean;
  comment: string;
};

export type BaseTestInstanceResponseMark = API_JSON & SmallestTestInstanceResponseMark;

// Types for displaying a list of marks:
export type TestInstanceResponseMarkWithActiveMarkerAndResponse = BaseTestInstanceResponseMark & {
  activeMarker?: API_JSON;
  testInstanceResponse: API_JSON;
  aiMarked: boolean;
  activeReviewer?: API_JSON;
};

// Types for displaying a particular mark:
export type MarkItem = {
  id: number;
  submittedOptions: API_JSON[];
  submittedValue: string;
  submittedScore: number;
  testInstanceResponseMarker: API_JSON;
  testRubricItem: API_JSON;
  testInstanceResponseItem: API_JSON;
};
export type TestInstanceResponseMarkWithItems = BaseTestInstanceResponseMark & {
  activeMarker?: API_JSON;
  markItems?: MarkItem[];
  markers: API_JSON[];
  tags: API_JSON[];
  aiMarked: boolean;
};

// Types for saving a mark:
export type PostAndPatchMarkFields = SmallestTestInstanceResponseMark & {
  activeMarkerId: number;
  testInstanceResponseId: number;
  testRubricId: number;
  tagIds: number[];
  activeReviewerId?: number;
};
export type PostTestInstanceResponseMark = PostAndPatchMarkFields & {
  testInstanceResponseMarkItems: PostTestInstanceResponseMarkItem[];
};
export type PatchTestInstanceResponseMark = {
  id: number;
  data: Partial<PostAndPatchMarkFields>;
};

// types for data specific to report hooks

export type ReportTestInstanceResponseMark = BaseTestInstanceResponseMark & {
  holisticComment: string | null;
  aiMarked: boolean;
  aiEngineService: API_JSON & { aiEngine: API_JSON };
  markers?: (API_JSON & { user: API_JSON })[];
  markItems?: ReportMarkItem[];
  testInstanceResponse: API_JSON;
};

export type ReportMarkItem = API_JSON & {
  comment?: string;
  submittedScore?: number;
  testRubricItem: API_JSON;
};
